import type { CalidadControlModificacion } from "../../../types/control-modificaciones";

export type CalidadDafoAnalisis = {
  id: number;
  anio: number;
  bloque: string;
  tipo: string;
  codigo: string;
  descripcion: string | null;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type CalidadDafoParteInteresada = {
  id: number;
  anio: number;
  parte_interesada: string | null;
  tipo: string | null;
  detalle: string | null;
  requisitos: string | null;
  seguimiento_primer_semestre: string | null;
  seguimiento_segundo_semestre: string | null;
  evaluacion_eficacia_acciones: string | null;
  usuario_modificacion_id: number | null;
  created_at: string | null;
  updated_at: string | null;
};

export type CalidadDafoAnalisisPayload = Omit<CalidadDafoAnalisis, "id" | "usuario_modificacion_id" | "created_at" | "updated_at">;
export type CalidadDafoParteInteresadaPayload = Omit<CalidadDafoParteInteresada, "id" | "usuario_modificacion_id" | "created_at" | "updated_at">;

export type DafoFilters = {
  anio: string;
  search: string;
  parte_interesada: string;
};

export type DafoParteResumen = {
  parte_interesada: string;
  total: number;
};

export type DafoResponse = {
  analisis: CalidadDafoAnalisis[];
  partes_interesadas: CalidadDafoParteInteresada[];
  control_modificaciones: CalidadControlModificacion[];
  partes_resumen: DafoParteResumen[];
  meta: {
    years: number[];
    current_year: number;
    default_source_year: number | null;
    suggested_new_year: number;
    analisis_total: number;
    partes_interesadas_total: number;
  };
};

export type DafoPlantillaAnualPayload = {
  source_year: number;
  target_year: number;
  copy_analisis: boolean;
  copy_partes_interesadas: boolean;
};

export const defaultDafoFilters: DafoFilters = {
  anio: "",
  search: "",
  parte_interesada: "",
};

export const DAFO_BLOQUES = ["CONTEXTO INTERNO", "CONTEXTO EXTERNO"] as const;
export const DAFO_TIPOS = ["DEBILIDAD", "FORTALEZA", "AMENAZA", "OPORTUNIDAD"] as const;

export function createEmptyAnalisisForm(anio?: number): CalidadDafoAnalisisPayload {
  return {
    anio: anio ?? new Date().getFullYear(),
    bloque: "CONTEXTO INTERNO",
    tipo: "DEBILIDAD",
    codigo: "",
    descripcion: "",
  };
}

export function createEmptyParteInteresadaForm(anio?: number, parteInteresada?: string): CalidadDafoParteInteresadaPayload {
  return {
    anio: anio ?? new Date().getFullYear(),
    parte_interesada: parteInteresada ?? "",
    tipo: "NECESIDAD",
    detalle: "",
    requisitos: "",
    seguimiento_primer_semestre: "",
    seguimiento_segundo_semestre: "",
    evaluacion_eficacia_acciones: "",
  };
}

export function mapAnalisisToPayload(row: CalidadDafoAnalisis): CalidadDafoAnalisisPayload {
  return {
    anio: row.anio,
    bloque: row.bloque,
    tipo: row.tipo,
    codigo: row.codigo,
    descripcion: row.descripcion ?? "",
  };
}

export function mapParteInteresadaToPayload(row: CalidadDafoParteInteresada): CalidadDafoParteInteresadaPayload {
  return {
    anio: row.anio,
    parte_interesada: row.parte_interesada ?? "",
    tipo: row.tipo ?? "",
    detalle: row.detalle ?? "",
    requisitos: row.requisitos ?? "",
    seguimiento_primer_semestre: row.seguimiento_primer_semestre ?? "",
    seguimiento_segundo_semestre: row.seguimiento_segundo_semestre ?? "",
    evaluacion_eficacia_acciones: row.evaluacion_eficacia_acciones ?? "",
  };
}
